import { ComponentProps, forwardRef, useState } from 'react'

import {
  FormItem,
  FormLabel,
  FormMessage,
  Icon,
  IconButton,
  TextField as TextFieldPrimitive,
} from 'components'

import styles from './styles.module.scss'

interface TextFieldProps extends ComponentProps<'input'> {
  label?: string
  message?: string
  appearance?: 'error' | 'neutral'
}

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (
    { label, message, autoComplete = 'off', appearance = 'neutral', ...props },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false)

    const id = `${label}-textfield`

    const isPassword = props.type === 'password'
    const type = isPassword ? (showPassword ? 'text' : 'password') : props.type

    return (
      <FormItem className={styles.container}>
        <div className={styles.fieldWrapper}>
          {label && (
            <FormLabel appearance={message ? 'error' : 'neutral'} htmlFor={id}>
              {label}
            </FormLabel>
          )}

          <TextFieldPrimitive
            id={id}
            placeholder=" "
            autoComplete={autoComplete}
            appearance={!!message ? 'error' : 'neutral'}
            {...props}
            ref={ref}
            type={type}
          />

          {isPassword && (
            <IconButton
              className={styles.password}
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <Icon
                color="element-default"
                name={showPassword ? 'hide' : 'view'}
              />
            </IconButton>
          )}
        </div>

        {message && (
          <FormMessage color="accent-red-default">{message}</FormMessage>
        )}
      </FormItem>
    )
  },
)

TextField.displayName = 'TextField'

export default TextField
